<div class="smlToastrContainer {{positionClass}}">
  <div class="smlToastrWrapper">
    <div *ngFor="let alert of alerts; let i = index" [@anim]="alert.isVisible ? windowPosition : null">
      <div class="{{cssClass(alert)}}" *ngIf="alert.isVisible">
        <span *ngIf="icon">
          <i-icon [name]="icon" class="!tw-block"></i-icon>
        </span>
        <div class="smlToastrContent tw-break-words tw-pt-0.5">
          <div *ngIf="alert.title" class="tw-font-normal tw-text-lg tw-leading-none" [innerHtml]="alert.title">&nbsp;</div>
          <div class="smlToastrMessage tw-text-sm tw-font-sans tw-font-medium" [innerHtml]="alert.message">&nbsp;</div>
        </div>
        <div class="smlToastrClose" *ngIf="isClose">
          <a href="javascript:void(0);" class="tw-block" (click)="removeAlert(alert)">
            <i-icon name="close" class="!tw-block"></i-icon>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
